import { ref, watch } from 'vue';

export const useResult = (props, configuration) => {
  const result = ref({
    file: null,
    preview: null,
    previewUrl: null,
  });
  const hasBespokeFile = ref(false);

  const setResult = (file, preview = null) => {
    result.value = { file, preview, previewUrl: preview ? URL.createObjectURL(preview) : null };
  };

  const setResultFromEngraving = async (options) => {
    setResult(
      await dataUrlToFile(options.engravingSVG, 'resultFile.svg'),
      await dataUrlToFile(options.engravingPreview, 'previewFile.png'),
    );
  };

  const setBespokeFile = async (file) => {
    let preview = null;
    if (file) {
      preview = file.type === 'application/pdf' ? await dataUrlToFile(props.pdfPlaceholder) : file;
    }

    setResult(file, preview);
    hasBespokeFile.value = !!file;
  };

  const dataUrlToFile = async (dataUrl, fileName) => {
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type });
  };

  watch(
    () => configuration.value.engraving,
    async (value) => {
      if (value !== 'bespoke') {
        await setBespokeFile(null);
      }
    },
  );

  return {
    result,
    hasBespokeFile,
    setResultFromEngraving,
    setBespokeFile,
  };
};
